import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';
import { apiKey } from '../../utils/ktcUtils';

const ElectionResults = () => {
  return (
    <div className=" mt-4" style={{ width: '95%', margin: 'auto' }}>
      <div className="alert alert-info text-center fs-5 fw-bold">
        Page-kan si kumeel gaar ah ayaa loo xayiray
      </div>
    </div>
  );
};

export default ElectionResults;
